<template>
  <div>
    <div class="w3-center">
      <br>
      <img src="../../../../static/img/boy.png" style="width:35%;"><br><br>
      <input type="radio" id="male" value="M" v-model="gender">
      <label for="male">Male</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <input type="radio" id="female" value="F" v-model="gender">
      <label for="female">Female</label>
    </div>
    <div>
      <form>
        <div style="margin-left: 5%; margin-top: 5%; width: 90%;">
          <input class="profile_edit" id="profile_name" placeholder="NAME"><br><hr>
          <input class="profile_edit" id="profile_email" placeholder="EMAIL"><br><hr>
          <input class="profile_edit" id="profile_referral" placeholder="REFERRAL CODE[OPTIONAL]"><br><hr>
          <br><br>
        </div>
        <input class="button1" value="SUBMIT" type="button" v-on:click="">
      </form>
    </div>
  </div>
</template>
<script>
  // import axios from 'axios'
  export default {
    data () {
      return {
        signUp: [],
        otp: false,
        gender: 'M'
      }
    },
    created () {
      if (sessionStorage.getItem('userId') === null) {
        this.$router.push('/a/reg')
      } else {
      }
    },
    methods: {
    }
  }
</script>
<style>
.profile_edit {background-color: transparent; border: 0px solid; padding-bottom: 1%; width: 100%;}
.button1 {background-color: #3CB6C3;width: 100%; padding: 3% 3% 3% 0%;}
.icon {font-size: xx-large; width: 25px;}
hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid gray;
    margin: 0em 0%;
    padding: 0; 
    margin-bottom: 5%;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Profile.vue